export default __webpack_public_path__ + "static/media/driver_color.6a4542fd.svg";